export default __webpack_public_path__ + "static/media/gemini.1cda9244.png";